import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.documentElement.setAttribute(
    'data-bs-theme',
    localStorage.getItem('theme') || 'light'
);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<BrowserRouter><App tab="home" /></BrowserRouter>);

reportWebVitals();